import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "label-none-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.5035 2.25012H7.49951C4.6003 2.25012 2.24951 4.60091 2.24951 7.50012V16.5041C2.24951 19.4013 4.5983 21.7501 7.49551 21.7501H16.5035C19.4006 21.7501 21.7495 19.4014 21.7495 16.5051V7.49612C21.7495 4.59891 19.4007 2.25012 16.5035 2.25012ZM3.74951 7.50012C3.74951 5.42934 5.42873 3.75012 7.49951 3.75012H16.5035C17.2689 3.75012 17.9806 3.97967 18.5737 4.37367L4.37442 18.5763C3.97959 17.9829 3.74951 17.2703 3.74951 16.5041V7.50012ZM5.43747 19.6346C6.0281 20.0237 6.73537 20.2501 7.49551 20.2501H16.5035C18.5724 20.2501 20.2495 18.5728 20.2495 16.5051V7.49612C20.2495 6.73511 20.0226 6.02708 19.6326 5.43604L5.43747 19.6346Z"
    }, null, -1)
  ])))
}
export default { render: render }